import {useEffect, useState} from 'react';
import {OutlinedQuestionCircle} from '@baidu/acud-icon';
import monitor from '@baidu/fe-monitor';
import {Tooltip} from 'acud';
import {LoginType} from '@/constants';
import {getInitParams, getLoadChannel} from '@/util';
import {getLastLoginType, getLoginType, isABCC, isLbsyun} from '../App/util';
import PassportWrap from './PassportWrap';
import UCWrap from './UCWrap';
import style from './index.less';

export default function RightWrap({
    extraClassName,
    isWap,
    initPass,
    initUC,
}: {
    extraClassName: string;
    isWap?: boolean;
    initPass: () => Promise<any>;
    initUC: () => Promise<any>;
}) {
    const [loginType, setLoginType] = useState(getLoginType());
    const lastLoginType = getLastLoginType();
    const hasPass = !isLbsyun();
    const hasUC = !isABCC();
    const {registerUcLink} = getInitParams();
    useEffect(() => {
        const channel = isWap ? 'wap' : getLoadChannel();
        if (loginType === LoginType.UC) {
            monitor.trackBehavior({
                name: `百度智能云控制台-login-${channel}登录页-默认登录方式`,
                category: '默认登录方式',
                action: 'click',
                value: 'uc-tab',
            });
        } else {
            monitor.trackBehavior({
                name: `百度智能云控制台-login-${channel}登录页-默认登录方式`,
                category: '默认登录方式',
                action: 'click',
                value: 'passport-tab',
            });
        }
    }, []);
    return (
        <>
            <div className={`right_wrap ${loginType === LoginType.UC ? ' uc-wrap' : ''}${extraClassName}`}>
                <div className="bce-login-type-tab">
                    {hasPass && (
                        <div
                            className={`passport-tab-btn${loginType === LoginType.UC ? '' : ' active'}${
                                lastLoginType === LoginType.PASSPORT ? ' last-login' : ''
                            }`}
                            onClick={() => setLoginType('passport')}
                        >
                            百度账号
                        </div>
                    )}
                    {hasUC && (
                        <div
                            className={`uc-tab-btn${loginType === LoginType.UC ? ' active' : ''}${
                                lastLoginType === LoginType.UC ? ' last-login' : ''
                            }`}
                            onClick={() => setLoginType(LoginType.UC)}
                        >
                            云账号
                            {!isWap && (
                                <Tooltip title="同百度营销账号">
                                    <OutlinedQuestionCircle
                                        style={{marginLeft: 8}}
                                        width={20}
                                        height={20}
                                        fill="#84868C"
                                        color="#84868C"
                                    />
                                </Tooltip>
                            )}
                        </div>
                    )}
                </div>
                <div className={`bce-passport-wrap ${loginType === LoginType.UC ? 'hide' : ''}`}>
                    <PassportWrap isWap={isWap} initFunc={initPass} />
                    {!isWap && <div id="other-login-bar-pass"></div>}
                </div>
                <div className={loginType === LoginType.UC ? '' : 'hide'}>
                    <UCWrap initFunc={initUC} />
                    <div id="other-login-bar-uc"></div>
                </div>
                {!isWap && (
                    <a href={registerUcLink} className={style['up-right-corner']}>
                        注册
                    </a>
                )}
            </div>
        </>
    );
}
